import { createRoute } from '@/utils/core';
import { P404 } from 'components/Pages';

const routesConfig = (app) => ({
  title: 'Page Not Found',
  component: P404,
});

export default (app) => createRoute(app, routesConfig);
